import { useMap } from 'ms-map-gl'
import { FC, useCallback, useEffect } from 'react'

type HoverPluginProps = {
  source: string
  layer: string
  sourceLayer?: string
}

export const HoverPlugin: FC<HoverPluginProps> = (props) => {
  const { source, layer, sourceLayer } = props
  const { default: map } = useMap()

  const handleMouseMove = useCallback(
    (e: any) => {
      if (!map) return
      map.getCanvas().style.cursor = 'pointer'
      map.removeFeatureState({ source: source, sourceLayer })
      if (e.features.length > 0) {
        map.setFeatureState(
          { source: source, sourceLayer, id: e.features[0].id },
          { hover: true }
        )
      }
    },
    [map, source, sourceLayer]
  )

  const handleMouseLeave = useCallback(() => {
    if (!map) return
    map.getCanvas().style.cursor = ''
    map.removeFeatureState({ source: source, sourceLayer })
  }, [map, source, sourceLayer])

  useEffect(() => {
    if (!map) return

    map.on('mousemove', layer, handleMouseMove)

    map.on('mouseleave', layer, handleMouseLeave)

    return () => {
      map.off('mousemove', layer, handleMouseMove)
      map.off('mouseleave', layer, handleMouseLeave)
    }
  }, [map, handleMouseMove, handleMouseLeave, layer])

  return <></>
}
